import { render, staticRenderFns } from "./privateBathroom.vue?vue&type=template&id=27572428&scoped=true"
import script from "./privateBathroom.vue?vue&type=script&lang=js"
export * from "./privateBathroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27572428",
  null
  
)

export default component.exports